import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  ALL_COUNTERS,
  APP_COUNTERS,
  OU_COUNTERS,
  LIST,
  LOADER,
  COUNTER_CALL_STATE,
  RIORG_IDENTITY,
  RIORG_OUS,
  RIORG_CALL_STATE,
} = STATE_IDENTIFIER;

export default {
  [ALL_COUNTERS]: { [LIST]: [], [LOADER]: false },
  [APP_COUNTERS]: { [LIST]: [], [LOADER]: false },
  [OU_COUNTERS]: { [LIST]: [], [LOADER]: false },
  [COUNTER_CALL_STATE]: IResponseState.PENDING,
  [RIORG_IDENTITY]: { [LIST]: [], [LOADER]: false },
  [RIORG_CALL_STATE]: IResponseState.PENDING,
  [RIORG_OUS]: [],
};
